import CommonModal from '@components/CommonModal';
import Size from '@modules/widgets/forms/CommandButtonWidgetModal/components/Size';
import Style from '@modules/widgets/forms/CommandButtonWidgetModal/components/Style';
import Grid from '@mui/material/Grid';
import { ObjectProperty } from '@src/__generated__/graphql';
import { WidgetTypesEnum } from '@utils/widgetTypes';
import { FastField } from 'formik';
import { create } from 'react-modal-promise';
import ActionName from './components/ActionName';
import Buttons from './components/Buttons';
import Description from './components/Description';
import Name from './components/Name';

import { Typography } from '@mui/material';
import useForm from './hooks/useForm';

export interface ILineWidgetModalProps {
  onResolve?: () => void;
  isOpen?: boolean;
  widget?: { id: string };
  isEdit?: boolean;
  widgetType?: WidgetTypesEnum;
  group?: {
    id: string;
    type: ObjectProperty;
    objectProperties: ObjectProperty[];
  };
  name?: string;
}

const ReactionWidgetModal = ({ onResolve, isOpen, widget, isEdit, group, name }: ILineWidgetModalProps) => {
  const { formik, isLoading } = useForm({ onResolve, widget, isEdit, group, name });

  return (
    <CommonModal
      key="EditObject"
      modalOpen={isOpen}
      title={isEdit ? 'Edit reaction button' : 'Add reaction button'}
      handleClose={onResolve}
      buttons={<Buttons isEdit={isEdit} handleClose={onResolve} />}
      isForm={true}
      loading={isLoading}
      formik={formik}
    >
      <Grid container direction="column" spacing={2}>
        <FastField name="name" placeholder="name" component={Name} />
        <FastField name="size" placeholder="size" component={Size} />
        <FastField name="style" placeholder="style" component={Style} />
        <Grid item>
          <Typography variant="subtitle2" color="primary">
            Parameters
          </Typography>
        </Grid>
        <FastField name="settingsActionName" placeholder="Action name" component={ActionName} />
        <FastField name="description" placeholder="description" component={Description} />
      </Grid>
    </CommonModal>
  );
};

export default create(ReactionWidgetModal);
